<div mat-dialog-content>
    <p translate>{{data?.message}}</p>
</div>

<div mat-dialog-actions fxLayoutAlign="center center" fxLayoutGap="10px">
    <button mat-button class="ok" [mat-dialog-close]="true">{{(data?.okText || 'Yes') | translate}}</button>
    <button *ngIf="!data?.hideCancel" mat-button class="cancel" (click)="onNoClick()">{{ "No" | translate}}</button>
</div>